import { type FunctionalComponent, h } from '@stencil/core';

// This a a generic component to handle events for GenAI
// Should not be used for specific logic like disabling events under special conditions
// The aim is to make it simpler to handle events, not to add complexity covering edge cases inside generic component

interface IEventEmitterComponent {
  eventName: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any; // For dynamic parameters
  isRightClickActive?: boolean;
  isDisabled?: boolean;
  isNotPropagatedForEnter?: boolean; // qds-inline-link is not triggering onClick on Enter
}

const EventEmitterComponent: FunctionalComponent<
  IEventEmitterComponent
> = ({ eventName, isRightClickActive, isDisabled, isNotPropagatedForEnter, ...props }, children) => {
    const handleClick = (e) => {
        if (isDisabled) return;
        const eventDetails = { ...props };

        if (isRightClickActive) {
          const clickType = e.type === 'contextmenu' ? 'Right' : 'Left';
          eventDetails.clickType = clickType;
        }

        window.dispatchEvent(new CustomEvent(eventName, { detail: eventDetails }));
    };

    return (
      <host
        onContextMenu={(e) => isRightClickActive ? handleClick(e) : void 0}
        onClick={(e) => handleClick(e)}
        onKeyDown={(e) => {if (e.key === 'Enter' && isNotPropagatedForEnter) {
          handleClick(e);
        }}}
      >
        {children}
      </host>
    );
};

export default EventEmitterComponent;
